import React from "react";

const ResolutionModal = ({ data, onClose }) => {
  if (!data || data.length === 0) return null;

  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalContainerStyle = {
    background: "#fff",
    width: "450px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    maxHeight: "80vh",
    overflowY: "auto",
  };

  const modalTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "10px",
    textAlign: "center",
    color: "#333",
    borderBottom: "1px solid #ddd",
    paddingBottom: "8px",
  };

  const modalContentStyle = {
    maxHeight: "65vh",
    overflowY: "auto",
  };

  const resolutionCardStyle = {
    background: "#f9f9f9",
    padding: "10px",
    marginBottom: "8px",
    borderRadius: "6px",
    borderLeft: "4px solid #007bff",
  };

  const tagContainerStyle = {
    marginTop: "6px",
    padding: "8px",
    background: "#eef2f7",
    borderRadius: "4px",
    borderLeft: "3px solid #007bff",
    fontSize: "12px",
  };

  const tagItemStyle = {
    listStyle: "none",
    padding: "3px 0",
  };

  const modalFooterStyle = {
    textAlign: "right",
    marginTop: "10px",
  };

  const closeButtonStyle = {
    background: "#d9534f",
    color: "white",
    border: "none",
    padding: "8px 14px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    transition: "background 0.2s ease-in-out",
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContainerStyle}>
        <h2 style={modalTitleStyle}>Resolution Details</h2>

        <div style={modalContentStyle}>
          {data.map((resolution, index) => (
            <div key={index} style={resolutionCardStyle}>
              <p style={{ fontSize: "13px", margin: "4px 0" }}>
                <strong>ID:</strong> {resolution.id}
              </p>
              <p style={{ fontSize: "13px", margin: "4px 0" }}>
                <strong>Code:</strong> {resolution.descriptor_Code}
              </p>
              <p style={{ fontSize: "13px", margin: "4px 0" }}>
                <strong>Description:</strong> {resolution.descriptor_ShortDesc}
              </p>
              <p style={{ fontSize: "12px", margin: "4px 0", color: "#555" }}>
                <strong>Updated:</strong> {resolution.updatedAt}
              </p>
              <p style={{ fontSize: "12px", margin: "4px 0", color: "#555" }}>
                <strong>Proposed By:</strong> {resolution.proposedBy}
              </p>
              <p style={{ fontSize: "12px", margin: "4px 0", color: "#555" }}>
                <strong>IsResolutionAccepted:</strong> {resolution.isResolutionAccepted}
              </p>
              <p style={{ fontSize: "12px", margin: "4px 0", color: "#555" }}>
                <strong>Accepted Resolution :</strong> {resolution.acceptedResolution}
              </p>

              {/* Display Tag Items if available */}
              {resolution.tagItems && resolution.tagItems.length > 0 && (
                <div style={tagContainerStyle}>
                  <strong>Tag Items:</strong>
                  <ul style={{ paddingLeft: "10px", margin: "4px 0" }}>
                    {resolution.tagItems.map((tag, tagIndex) => (
                      <li key={tagIndex} style={tagItemStyle}>
                        <strong>{tag.descriptorCode}:</strong> {tag.value}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={modalFooterStyle}>
          <button style={closeButtonStyle} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResolutionModal;
